interface IProps {
  content: any;
}

const SalesPerson = ({ content }: IProps) => {
  return content;
};

export default SalesPerson;
